import { render, staticRenderFns } from "./ClientDemographicsWork.vue?vue&type=template&id=28691003"
import script from "./ClientDemographicsWork.vue?vue&type=script&lang=js"
export * from "./ClientDemographicsWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports